import { render, staticRenderFns } from "./ImportBCModal.vue?vue&type=template&id=c26ed3ce&scoped=true&"
import script from "./ImportBCModal.vue?vue&type=script&lang=js&"
export * from "./ImportBCModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26ed3ce",
  null
  
)

export default component.exports